"use client"

import { Canvas } from "@react-three/fiber"
import { OrbitControls, Float, MeshDistortMaterial, Sphere, Environment } from "@react-three/drei"

function AnimatedSphere() {
    return (
        <Float speed={2} rotationIntensity={0.5} floatIntensity={0.5}>
            <Sphere args={[1, 100, 200]} scale={2.5}>
                <MeshDistortMaterial
                    color="#5b7de6"
                    attach="material"
                    distort={0.3}
                    speed={2}
                    roughness={0.2}
                    metalness={0.8}
                />
            </Sphere>
        </Float>
    )
}

function Particles() {
    const particles = Array.from({ length: 50 }, (_, i) => ({
        id: i,
        position: [(Math.random() - 0.5) * 20, (Math.random() - 0.5) * 20, (Math.random() - 0.5) * 20] as [
            number,
            number,
            number,
        ],
        scale: Math.random() * 0.1 + 0.05,
    }))

    return (
        <>
            {particles.map((particle) => (
                <Float key={particle.id} speed={1} rotationIntensity={0.5} floatIntensity={2}>
                    <Sphere args={[particle.scale, 16, 16]} position={particle.position}>
                        <meshStandardMaterial color="#8ba7f0" emissive="#5b7de6" emissiveIntensity={0.5} />
                    </Sphere>
                </Float>
            ))}
        </>
    )
}

export function VRScene() {
    return (
        <div className="h-full w-full opacity-40">
            <Canvas camera={{ position: [0, 0, 8], fov: 45 }}>
                <ambientLight intensity={0.5} />
                <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} intensity={1} />
                <pointLight position={[-10, -10, -10]} intensity={0.5} />

                <AnimatedSphere />
                <Particles />

                <Environment
                    files="/assets/hdri/dikhololo_night_1k.hdr"
                    background
                />
                <OrbitControls enableZoom={false} enablePan={false} autoRotate autoRotateSpeed={0.5} />
            </Canvas>
        </div>
    )
}
